import { render, staticRenderFns } from "./CathayPropertyHealthInsurance.vue?vue&type=template&id=b4299846"
import script from "./CathayPropertyHealthInsurance.vue?vue&type=script&lang=js"
export * from "./CathayPropertyHealthInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports